module.exports = __webpack_public_path__ + "img/sourcing_admin.65c0760c.svg";